module.exports = __webpack_public_path__ + "img/icon_4.d0e5c4bb.svg";